import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EnumValues, BreadcrumbService } from '@card-software/library';
import { SiteService } from '@card-software/nexus-utilities';
import { Shipment, ShipmentStatus } from '../../../models/order/shipment';
import { ShipmentProxyService } from '../../../proxies/order/shipment.proxy.service';
import { EnumService } from '../../../services/enum.service';
import moment from 'moment';

// Northern Textiles is the only site that still labels this module "Yarn Warehouse Imports".
// Every other site uses the generic "Warehouse Imports" wording.
const NORTHERN_TEXTILES_SITE_ID = '698d23639742c79b2f8cb1f1';
@Component({
  selector: 'app-warehouse-imports',
  templateUrl: './warehouse-imports.component.html',
  styleUrl: './warehouse-imports.component.scss',
})
export class WarehouseImportsComponent implements OnInit {
  isLoading = 0;

  get titleKey(): string {
    return SiteService.getSelectedSiteId() === NORTHERN_TEXTILES_SITE_ID ? 'Warehouse_Imports_Title' : 'Warehouse_Imports_Title_Generic';
  }

  get titleFallback(): string {
    return SiteService.getSelectedSiteId() === NORTHERN_TEXTILES_SITE_ID ? 'Yarn Warehouse Imports' : 'Warehouse Imports';
  }

  allShipments: Shipment[] = [];
  status: EnumValues;
  private readonly breadcrumbService = inject(BreadcrumbService);
  constructor(
    private _router: Router,
    private shipmentProxyService: ShipmentProxyService,
    private enumService: EnumService,
  ) {
    this.breadcrumbService.set([{ label: this.titleKey }]);
    this.status = this.enumService.getEnum('ShipmentStatus', 'order').values;
  }

  ngOnInit() {
    this.isLoading++;
    this.shipmentProxyService.getShipments().subscribe({
      next: (response) => {
        const shipments = response.data;
        if (shipments) {
          this.isLoading--;
          this.allShipments = shipments;
        }
      },
      error: (error) => {
        this.isLoading--;
        console.log('Error loading shipments', error);
      },
    });
  }

  getIncomingShipments() {
    return this.allShipments.filter((shipment) => {
      return (
        shipment.status === ShipmentStatus.Arrived ||
        shipment.status === ShipmentStatus.InCustoms ||
        shipment.status === ShipmentStatus.InRoute ||
        shipment.status === ShipmentStatus.ReadyToUnload ||
        shipment.status === ShipmentStatus.Unloading
      );
    });
  }

  getCompletedShipments() {
    return this.allShipments.filter((shipment) => {
      return shipment.status === ShipmentStatus.Completed;
    });
  }

  redirectToDetails(shipmentid?: string) {
    this._router.navigate(['warehouse-import-details'], {
      queryParams: { id: shipmentid },
    });
  }

  getFormatedDate(date: string) {
    return moment(date).format('YYYY-MM-DD');
  }

  statusFormatted(status: string) {
    // transform from EnumPascalCase to Enum Normal Case using lodash
    // e.g. "ReadyToUnload" -> "Ready To Unload"
    // Make sure lodash is installed and imported
    // import { startCase } from 'lodash';
    // return startCase(status);
    return status
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  }
}
